module.exports = __webpack_public_path__ + "static/media/coffee.a1da47da.png";